<template>
  <div>
    <b-row style="margin-top: 4em">
      <b-col cols="12" sm="12" md="2">
        <ulu-logo :brand="order.brand" />
      </b-col>
      <b-col>
        <h2 class="text-secondary">
          <i>{{ $t("globals.order").toUpperCase() + " " + order.order_no }}</i>
        </h2>
        <h6 class="text-secondary">
          <router-link
            style="color:#17a2b8"
            :to="{ name: 'inquiry', params: { id: order.inquiry.id } }"
          >
            {{ $t("globals.inquiry") + " " + order.inquiry.inquiry_no }}
          </router-link>
          <span
            v-if='order.cancell_at && order.cancell_at !== null && order.cancell_at !== ""'
            v-b-tooltip.hover
            :title="$t('status.' + order.cancell_type)"
            class='ml-2'
          >
            <b-badge>
              {{ $t("globals.cancel_at") + ': ' + order.cancell_at.substring(0, 10) }}
            </b-badge>
          </span>
        </h6>
      </b-col>
      <b-col>
        <b-dropdown
          size="sm"
          right
          variant="info"
          class="float-right m-1"
          :text="$t('globals.more')"
        >
          <b-dropdown-item
            v-if="
              order.status === 'completed' &&
                getUserBrandPermissions.order_terminate
            "
            @click="terminate"
            variant="danger"
          >
            {{ $t("globals.terminate") }}
          </b-dropdown-item>
          <b-dropdown-item
            v-if="getUserBrandPermissions.order_cancel && order.cancell_at == null"
            @click="showCancellModal = true"
            variant="danger"
          >
            {{ $t("globals.cancel_order") }}
          </b-dropdown-item>
          <b-dropdown-item
            v-if="getUserBrandPermissions.order_cancel && order.send_invoices === true "
            @click="changeSendInvoices(true)"
            variant="danger"
          >
            {{ $t("globals.disable_sending_invoices")}}
          </b-dropdown-item>
          <b-dropdown-item
            v-if="getUserBrandPermissions.order_cancel && order.send_invoices === false "
            @click="changeSendInvoices(false)"
            variant="danger"
          >
            {{ $t("globals.enable_sending_invoices")}}

          </b-dropdown-item>
          <b-dropdown-item
            v-if='showCancelCancellationBtn'
            @click="cancelCancellation"
            variant="info"
          >
            {{ $t("globals.cancel_cancellation") }}
          </b-dropdown-item>
          <b-dropdown-item
            v-if="deleteBtnShow"
            variant="danger"
            @click="deleteOrderModal.show = true"
          >
            {{ $t("globals.hard_delete") }}
          </b-dropdown-item>
          <!-- with admin permission -->
          <b-dropdown-divider
            v-if="getUserBrandPermissions.super_admin"
          ></b-dropdown-divider>
          <b-dropdown-item
            v-if="getUserBrandPermissions.super_admin"
            variant="info"
            @click="showChangeAgentModal = true"
          >
            {{ $t("globals.change_agent") }}
          </b-dropdown-item>
          <b-dropdown-item
            v-if="getUserBrandPermissions.super_admin"
            variant="info"
            @click="showChangePaymentTypeModal = true"
          >
            {{ $t("globals.change_payment_type") }}
          </b-dropdown-item>
        </b-dropdown>
        <b-btn
          v-if="
            order.status === 'created' || order.status === 'devices_imported'
          "
          @click="complete"
          class="float-right m-1"
          size="sm"
          variant="success"
          :disabled="!getUserBrandPermissions.order_complete"
        >
          {{ $t("globals.complete") }}
        </b-btn>
      </b-col>
    </b-row>
    <b-modal
      centered
      :visible="deleteOrderModal.show"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-container>
        <b-row>
          <b-col>
            <h4>{{ $t("globals.delete") + " " + $t("globals.order") }}</h4>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col>
            <b-form-checkbox
              v-model="deleteOrderModal.delete_inquiry"
              :value="true"
              :unchecked-value="false"
            >
              {{ $t("globals.delete_also_inquiry") }}
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h6 class="text-secondary m-2">
              {{ "*" + $t("globals.left_unchecked_pending") }}
            </h6>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col>
            <b-btn size="sm" variant="success" @click="deleteOrder">
              {{ $t("globals.delete") }}
            </b-btn>
          </b-col>
          <b-col>
            <b-btn
              class="float-right"
              size="sm"
              @click="deleteOrderModal.show = false"
              variant="warning"
            >
              {{ $t("globals.cancel") }}
            </b-btn>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <ulu-change-agent-modal
      :show="showChangeAgentModal"
      :close="closeModals"
    />
    <ulu-change-payment-type-modal
      :show="showChangePaymentTypeModal"
      :close="closeModals"
    />
    <ulu-cancell-modal
      :show="showCancellModal"
      :close="closeModals"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    "ulu-logo": () => import("@/components/common/Logo.vue"),
    "ulu-change-agent-modal": () =>
      import("@/components/orders/order/order_header/ChangeAgentModal"),
    "ulu-change-payment-type-modal": () =>
      import("@/components/orders/order/order_header/ChangePaymentTypeModal"),
    "ulu-cancell-modal": () =>
      import("@/components/orders/order/order_header/CancellModal")
  },
  props: {
    order: {
      type: Object,
      default: () => {
        return {
          order_no: 0,
          brand: "",
          status: "",
          send_invoices: true,
          inquiry: {
            inquiry_no: 0,
            id: 0
          }
        };
      }
    },
    refreshOrder: Function
  },
  data() {
    return {
      showChangeAgentModal: false,
      showChangePaymentTypeModal: false,
      showCancellModal: false,
      showMakeSynatecOrderModal: false,
      deleteOrderModal: {
        show: false,
        delete_inquiry: false
      },
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation"]),
    closeModals() {
      this.showChangePaymentTypeModal = false;
      this.showChangeAgentModal = false;
      this.showCancellModal = false;
      this.showMakeSynatecOrderModal = false;

      this.refreshOrder();
    },
    toInquiry() {
      this.$router.push({
        name: "inquiry",
        params: { id: this.order.inquiry.id }
      });
    },
    complete() {
      let data = {
        query: `mutation { res: OrderComplete (order_id: ${parseInt(
          this.$route.params.id
        )} ) }`
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.refreshOrder();
      });
    },
    terminate() {
      let confirmText = "Are you sure you want to terminate this order?";
      confirmText += " *All ACTIVE devices will be terminated!*";

      let data = {
        query: `
          mutation { 
            res: OrderTerminate(order_id: ${parseInt(this.$route.params.id)} )
          }
        `
      };

      this.simpleMutation({
        data,
        this_ref: this,
        confirm_text: confirmText
      }).then(() => {
        this.refreshOrder();
      });
    },
    changeSendInvoices(current_state_of_sending) {

      let confirmText = "Are you sure you want to change invoice scheduling for this order?";
      if(current_state_of_sending == true) {
        confirmText += " *All Future chedules will be canceled!*";
      } else {
        confirmText += " *Future schedules will be enabled again or created!*";
      }


      let data = {
        query: `
          mutation {
            res: OrderChangeSendInvoices(order_id: ${parseInt(this.$route.params.id)} )
          }
        `
      };

      this.simpleMutation({
        data,
        this_ref: this,
        confirm_text: confirmText
      }).then(() => {
        this.refreshOrder();
      });
    },
    cancelOrder() {
      let confirm_text = "Are you sure you want to cancel this order?";

      let data = {
        query: `
          mutation { 
            res: OrderCancel(order_id: ${parseInt(this.$route.params.id)} )
          }
        `
      };

      this.simpleMutation({ data, this_ref: this, confirm_text })
        .then(() => {
          this.refreshOrder();
        });
    },
    cancelCancellation() {
      let confirm_text = "Are you sure you want to cancel the cancellation?";

      let data = {
        query: `
          mutation { 
            res: OrderCancelCancellation (
              order_id: ${parseInt(this.$route.params.id)}
            )
          }
        `
      };

      this.simpleMutation({ data, this_ref: this, confirm_text })
        .then(() => { this.refreshOrder(); });
    },
    deleteOrder() {
      let confirm_text = "Are you sure you want to delete this order? (This action can NOT be reversed)";

      let data = {
        query: `
          mutation {
            res: OrderDelete(
              order_id: ${parseInt(this.$route.params.id)},
              delete_inquiry: ${this.deleteOrderModal.delete_inquiry}
            )
          }
        `
      };

      this.simpleMutation({ data, this_ref: this, confirm_text }).then(() => {
        this.deleteOrderModal.show = false;
        if (this.deleteOrderModal.delete_inquiry) {
          this.$router.push({ name: "allinquiries" });
        } else {
          this.$router.push({
            name: "inquiry",
            params: { id: this.order.inquiry.id }
          });
        }
      });
    }
  },
  computed: {
    ...mapGetters(["getUserBrandPermissions"]),
    deleteBtnShow() {
      return (
        this.order.status != "" &&
        this.order.status != "completed" &&
        this.order.status != "terminated" &&
        this.order.status != "canceled" &&
        this.getUserBrandPermissions.order_uncomplete_delete
      );
    },
    showCancelCancellationBtn() {
      return (
        this.getUserBrandPermissions.order_cancel
        && this.order.cancell_at !== null
        && this.order.status === 'completed'
      );
    }
  }
};
</script>
